import {FC, useState, useEffect} from 'react'
import Loader from 'react-loader-spinner'

import {colorCodes} from 'definitions/constant'

export const LoadingSpinner: FC<{
  color?: string
  type?:
    | 'Audio'
    | 'BallTriangle'
    | 'Bars'
    | 'Circles'
    | 'Grid'
    | 'Hearts'
    | 'Oval'
    | 'Puff'
    | 'Rings'
    | 'TailSpin'
    | 'ThreeDots'
    | 'Watch'
    | 'RevolvingDot'
    | 'Triangle'
    | 'Plane'
    | 'MutatingDots'
    | 'CradleLoader'
  height?: number
  width?: number
  classes?: string
  isLoading?: boolean
  ariaLabel?: string
  dataCy?: string
}> = ({
  color = colorCodes.cyanDark,
  type = 'Hearts',
  height = 50,
  width = 50,
  classes = '',
  isLoading = false,
  ariaLabel = 'Loading',
  dataCy = 'loading',
}) => {
  const [displayLoader, setDisplayLoader] = useState(isLoading)
  useEffect(() => {
    const timer = setTimeout(() => {
      setDisplayLoader(true)
    }, 0)
    // Clear timeout if the component is unmounted
    return () => clearTimeout(timer)
  })

  if (displayLoader)
    return (
      <span
        role="progressbar"
        className={classes}
        aria-label={ariaLabel}
        data-cy={dataCy}
      >
        <Loader type={type} color={color} height={height} width={width} />
      </span>
    )
  return null
}
